import React, { type FC } from "react";

import styled from "@emotion/styled";
import { useIntl } from "react-intl";

import {
  Flex,
  TEXT_VARIANT_BOLD_LIGHT,
  TEXT_VARIANT_LIGHT,
  Text,
  TooltipUtils,
} from "mailup-web-components";

import { stringOrDefault } from "Helpers/strings";

import RenderWhen from "Components/RenderWhen";
import type {
  ChannelSubscriptionStatus,
  SearchResult,
} from "Pages/RecipientsList/model";
import IconHelpBadge from "../../../../icons/iconHelpBadge.svg";

const StyledHelpIcon = styled.img`
  width: 14px;
  height: 14px;
  cursor: pointer;
`;

const getStatusFilter = (status: ChannelSubscriptionStatus): string => {
  switch (status) {
    case "SUBSCRIBED":
      return "brightness(0) saturate(100%) invert(62%) sepia(43%) saturate(600%) hue-rotate(108deg) brightness(90%)";
    case "PENDING":
      return "brightness(0) saturate(100%) invert(66%) sepia(100%) saturate(1200%)";
    case "UNSUBSCRIBED":
      return "brightness(0) saturate(100%) invert(55%) sepia(90%) saturate(1200%) hue-rotate(325deg) brightness(108%)";
    default:
      return "brightness(0) saturate(100%) invert(52%)";
  }
};

interface SmsSubscriptionDetailsProps {
  recipient: SearchResult;
  status: ChannelSubscriptionStatus;
}

const SmsSubscriptionDetails: FC<SmsSubscriptionDetailsProps> = ({
  recipient,
  status,
}) => {
  const intl = useIntl();

  return (
    <>
      <TooltipUtils
        id="sms-subscription-details-tooltip"
        type="light"
        effect="solid"
        className="c-tooltip"
        place="bottom"
      >
        <Flex flexDirection="column" gap="8px">
          {/* Iscrizione */}
          <section>
            <Text variant={TEXT_VARIANT_BOLD_LIGHT}>
              {intl.formatMessage({
                id: "Load.RecipientsList.Subscription",
              })}
            </Text>
            <Flex alignItems="center" gap="16px">
              <Text variant={TEXT_VARIANT_LIGHT}>
                {stringOrDefault(recipient.SMSSubscriptionDateExt, "-")}
              </Text>
              <Text variant={TEXT_VARIANT_LIGHT}>
                IP: {stringOrDefault(recipient.SMSSubscriptionRequestIP, "-")}
              </Text>
            </Flex>
          </section>

          {/* Disiscrizione */}
          <RenderWhen
            condition={recipient.SMSUnsubscriptionDateExt !== undefined}
          >
            <section>
              <Text variant={TEXT_VARIANT_BOLD_LIGHT}>
                {intl.formatMessage({
                  id: "Load.Common.Unsubscription",
                })}
              </Text>
              <Text variant={TEXT_VARIANT_LIGHT}>
                {stringOrDefault(recipient.SMSUnsubscriptionDateExt, "-")}
              </Text>
            </section>
          </RenderWhen>
        </Flex>
      </TooltipUtils>
      <StyledHelpIcon
        src={IconHelpBadge}
        alt=""
        style={{ filter: getStatusFilter(status) }}
        data-tip
        data-for="sms-subscription-details-tooltip"
      />
    </>
  );
};

export default SmsSubscriptionDetails;
